import { Dayjs } from 'dayjs'
import { ValidateRes } from 'src/service/OrgSyncService'
import { create } from 'zustand'

type State = {
  templateId?: string
  destinationProjectId?: number
  startDate?: Dayjs
  canvasPng?: Record<string, string>
  migrateRes?: ValidateRes
}

type Action = {
  setTemplateId: (templateId: string) => void
  setDestinationProjectId: (destinationProjectId: number) => void
  setStartDate: (startDate: Dayjs) => void
  setCanvasPng: (templateId: string, png: string) => void
  setMigrateRes: (migrateRes: ValidateRes) => void
}
type MigrateStore = State & Action

const useMigrateStore = create<MigrateStore>((set) => ({
  canvasPng: {},
  setTemplateId: (templateId) => set({ templateId }),
  setDestinationProjectId: (destinationProjectId) =>
    set({ destinationProjectId }),
  setStartDate: (startDate) => set({ startDate }),
  setCanvasPng: (templateId, png) =>
    set((state) => ({
      canvasPng: { ...state.canvasPng, [templateId]: png },
    })),
  setMigrateRes: (migrateRes) => set({ migrateRes }),
}))

export default useMigrateStore
